<template>
  <div>
    <a-time-unit-field
      :formLayout="formLayout"
      :size="size"
      :data="data"
      parentName="jwt_token_options"
      varName="refresh_token"
      varVerbose="Refresh Token"
      :units="rt_units"
    />
    <a-time-unit-field
      :formLayout="formLayout"
      :size="size"
      :data="data"
      parentName="jwt_token_options"
      varName="access_token"
      varVerbose="Access Token"
    />
    <a-select-field
      :formLayout="formLayout"
      :size="size"
      varName="jwt_token_options.access_token.token_type"
      varLabel="Access Token Type"
      :varRequired="true"
      :varInitial="data.jwt_token_options.access_token.token_type"
      :disabled="true"
      type="schema"
      :varOptions="token_type"
      description="Access token type: jwt, opaque. Currently jwt is only supported type."
    />
    <a-select-field
      :formLayout="formLayout"
      :size="size"
      varName="jwt_token_options.access_token.signing_alg"
      varLabel="Signing Algorithm"
      :varRequired="true"
      :varInitial="data.jwt_token_options.access_token.signing_alg"
      :disabled="true"
      type="schema"
      :varOptions="Algorithms"
      description="Signing algorithm for jwt-based access token"
    />
    <a-select-field
      varName="jwt_token_options.access_token.allowed_claims"
      varLabel="Allowed Claims"
      :varRequired="true"
      :varInitial="data.jwt_token_options.access_token.allowed_claims"
      :formLayout="formLayout"
      :size="size"
      :varOptions="claims"
      type="array"
      varMode="multiple"
      description="List of claims allowed to be included in the issued access token."
    />
  </div>
</template>

<script>
import Algorithms from '@/configs/SigningAlgorithm.js';

export default {
  data() {
    return {
        Algorithms,
        token_type: ['jwt', 'opaque'],
        rt_units: ['days', 'months', 'never'],
        claims: [
                'openid',
                'profile',
                'email',
                'phone',
                'address',
                'roles',
                'permissions',
                'orgs'
              ]
    };
  },
  props: {
    formLayout: String,
    size: String,
    data: Object,
    options: Object
  }
};
</script>
